export default __webpack_public_path__ + "static/media/NoirPro-SemiBold.f631a808.woff";